import { Cartesian2, Cartesian3, defined } from 'cesium';


const getTop = (top, height, type) => {
    if (type === 'top') {
        return top
    } else if (type === 'bottom') {
        return top - height
    } else if (type === 'center') {
        return top - height / 2
    }

    return top
}

const getLeft = (left, width, type) => {
    if (type === 'left') {
        return left
    } else if (type === 'right') {
        return left - width
    } else if (type === 'center') {
        return left - width / 2
    }

    return left
}

const getTopLeft = (ele, canvasPosition, positioning) => {
    const width = ele.offsetWidth;
    const height = ele.offsetHeight;

    const top = canvasPosition.y;
    const left = canvasPosition.x;

    const [v, h] = positioning.split('-');

    return [getTop(top, height, v), getLeft(left, width, h)]
}

export default class Dom {
    constructor(options) {
        const {element, position, positioning, map} = options;

        this.map = map;

        this.element = element;

        this.position = position;

        this.positioning = positioning || 'bottom-center';

        this.loadData();
    }

    setPosition(position) {
        this.position = position;

        this.loadData();
    }

    loadData() {
        const _this = this;
        const map = this.map;
        const position = this.position;
        map.scene.preRender.removeEventListener(_this.render.bind(_this));

        if (position?.length) {
            this._style = {};
            map.scene.preRender.addEventListener(_this.render.bind(_this));
        }
    }

    render() {
        const map = this.map;
        const position = this.position;
        if (position?.length) {

            let scratch = new Cartesian2();
            let point = Cartesian3.fromDegrees(position[0], position[1], position[2] || 0);

            let canvasPosition = map.scene.cartesianToCanvasCoordinates(
                point,
                scratch
            );

            if (defined(canvasPosition)) {
                const [top, left] = getTopLeft(this.element, canvasPosition, this.positioning);

                if (this._style.left) {
                    this._style.left = ((this._style.left - left > 1) || (this._style.left - left < -1)) ? left : this._style.left;
                } else {
                    this._style.left = left;
                }

                this._style.top = top;

                this.element.style.top = top +"px";
                this.element.style.left = left + "px";

                // const cameraPosition = map.camera.position;
                // let height = map.scene.globe.ellipsoid.cartesianToCartographic(cameraPosition)
                //     .height;
                // height += map.scene.globe.ellipsoid.maximumRadius;
                // if (!(Cartesian3.distance(cameraPosition, position) > height)) {
                //     this.element.style.display = 'block';
                // } else {
                //     this.element.style.display = 'none';
                // }
            }
        }
    }

    destroy() {
        const _this = this;
        this.map.scene.preRender.removeEventListener(_this.render.bind(_this));
    }
}
